import { Heading, Stack, vars } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css, cx } from '@eti/styles';
import { useHeightAboveStickyFooter } from '../../hooks/useHeightAboveStickyFooter';
import { asideStyles } from './styles';
import SingleTravelerButton from './SingleTravelerButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const stackWrapper = css`
  background: ${vars.colors.surface.primary};
  border: 1px solid ${vars.colors.divider};
  border-radius: ${vars.card.borderRadius};
  justify-content: space-around;
  overflow-y: auto;
  padding: 16px;
`;
const stackHeight = {
  dialog: css`
    max-height: calc(90vh - 220px);
  `,
  inline: css`
    max-height: calc(100vh - 200px);
  `
};
const SeatMapTravelers = ({
  activeSeatAssignments,
  activeSegment,
  activeTraveler,
  isRyanairInTrip,
  onChange,
  onRemoveSeat,
  seatTravelers,
  setTravelerButtonWithRemoveLink,
  shouldRenderInline,
  travelerButtonWithRemoveLink
}) => {
  const {
    t
  } = useTranslation();
  const passengerInformationHeading = t('Product.SeatMap.Passenger.Information.Header.Label');
  const isSingleTraveler = seatTravelers.length === 1;
  const {
    maxHeight,
    ref: cardListRef
  } = useHeightAboveStickyFooter(shouldRenderInline);
  return /*#__PURE__*/_jsxs(Stack, {
    as: "aside",
    className: cx(asideStyles.base, {
      [asideStyles.top.noOffset]: !shouldRenderInline,
      [asideStyles.top.withOffset]: shouldRenderInline
    }),
    "data-testid": "seatMap-travelers",
    children: [/*#__PURE__*/_jsx(Heading, {
      level: 3,
      children: passengerInformationHeading
    }), /*#__PURE__*/_jsx(Stack, {
      className: cx(stackWrapper, shouldRenderInline ? stackHeight.inline : stackHeight.dialog),
      ref: cardListRef,
      style: maxHeight ? {
        maxHeight
      } : undefined,
      children: seatTravelers.map(traveler => /*#__PURE__*/_jsx(SingleTravelerButton, {
        activeSeatAssignments: activeSeatAssignments,
        activeSegment: activeSegment,
        activeTraveler: activeTraveler,
        isRyanairInTrip: isRyanairInTrip,
        isSingleTraveler: isSingleTraveler,
        onChange: onChange,
        onRemoveSeat: onRemoveSeat,
        setTravelerButtonWithRemoveLink: setTravelerButtonWithRemoveLink,
        traveler: traveler,
        travelerButtonWithRemoveLink: travelerButtonWithRemoveLink
      }, traveler.id))
    })]
  });
};
export default SeatMapTravelers;
//# sourceMappingURL=SeatMapTravelers.js.map